import React, { Component } from "react";
import PdfH5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import "./index.less";
export default class PdfWeb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentDidMount() {
    let { state } = this.props.location;
    if (state.pdfData) {
      new PdfH5("#demo", {
        pdfurl: state.pdfData,
        lazy: true,
      });
    }
  }
  render() {
    const { data } = this.state;
    return <div id="demo" className="pdf-wrapper"></div>;
  }
}
